import { TEMPORADA } from '../utilidades/constants'

/**
https://www.lascuatroestacionesdelsabor.es/participar/agroejido
https://www.lascuatroestacionesdelsabor.es/participar/agroiris
https://www.lascuatroestacionesdelsabor.es/participar/agroponiente
https://www.lascuatroestacionesdelsabor.es/participar/balcondenijar
https://www.lascuatroestacionesdelsabor.es/participar/biosolportocarrero
https://www.lascuatroestacionesdelsabor.es/participar/camposeven
https://www.lascuatroestacionesdelsabor.es/participar/ecoinver
https://www.lascuatroestacionesdelsabor.es/participar/ejidomar
https://www.lascuatroestacionesdelsabor.es/participar/fruca
https://www.lascuatroestacionesdelsabor.es/participar/hortamar
https://www.lascuatroestacionesdelsabor.es/participar/indasol
https://www.lascuatroestacionesdelsabor.es/participar/gava
https://www.lascuatroestacionesdelsabor.es/participar/lashortichuelas
https://www.lascuatroestacionesdelsabor.es/participar/naturaldemontana
https://www.lascuatroestacionesdelsabor.es/participar/naturechoice
https://www.lascuatroestacionesdelsabor.es/participar/toledanohorticola
https://www.lascuatroestacionesdelsabor.es/participar/unica
https://www.lascuatroestacionesdelsabor.es/participar/vicasol
https://www.lascuatroestacionesdelsabor.es/participar/lapalma
https://www.lascuatroestacionesdelsabor.es/participar/rijkzwaan
 */

const clientes = [
    {
        nombre: 'Agroejido',
        url: '/participar/agroejido',
        codigo: 'agroejido',
        logo: `/assets/img/marcas/${TEMPORADA}/agroejido.jpg`,
        descripcion: '',
        stand: '9C19',
        pabellon: 'P09',
    },
    {
        nombre: 'Agroiris',
        url: '/participar/agroiris',
        codigo: 'agroiris',
        logo: `/assets/img/marcas/${TEMPORADA}/agroiris.jpg`,
        descripcion: '',
        stand: '9C14',
        pabellon: 'P09',
    },
    {
        nombre: 'Agroponiente',
        url: '/participar/agroponiente',
        codigo: 'agroponiente',
        logo: `/assets/img/marcas/${TEMPORADA}/agroponiente.jpg`,
        descripcion: '',
        stand: '9D05',
        pabellon: 'P09',
    },
    {
        nombre: 'Balcón de Níjar',
        url: '/participar/balcondenijar',
        codigo: 'balcondenijar',
        logo: `/assets/img/marcas/${TEMPORADA}/balcondenijar.jpg`,
        descripcion: '',
        stand: '9B07',
        pabellon: 'P09',
    },
    {
        nombre: 'BioSol Portocarrero',
        url: '/participar/biosolportocarrero',
        codigo: 'biosolportocarrero',
        logo: `/assets/img/marcas/${TEMPORADA}/biosolportocarrero.jpg`,
        descripcion: '',
        stand: '3A06A',
        pabellon: 'P03',
    },
    {
        nombre: 'Camposeven',
        url: '/participar/camposeven',
        codigo: 'camposeven',
        logo: `/assets/img/marcas/${TEMPORADA}/camposeven.jpg`,
        descripcion: '',
        stand: '7A08A',
        pabellon: 'P07',
    },
    {
        nombre: 'Ecoinver',
        url: '/participar/ecoinver',
        codigo: 'ecoinver',
        logo: `/assets/img/marcas/${TEMPORADA}/ecoinver.jpg`,
        descripcion: '',
        stand: '9C09A',
        pabellon: 'P09',
    },
    {
        nombre: 'Ejidomar',
        url: '/participar/ejidomar',
        codigo: 'ejidomar',
        logo: `/assets/img/marcas/${TEMPORADA}/ejidomar.jpg`,
        descripcion: '',
        stand: '9B08',
        pabellon: 'P09',
    },
    {
        nombre: 'Fruca',
        url: '/participar/fruca',
        codigo: 'fruca',
        logo: `/assets/img/marcas/${TEMPORADA}/fruca.jpg`,
        descripcion: '',
        stand: '7D07',
        pabellon: 'P07',
    },
    {
        nombre: 'Hortamar',
        url: '/participar/hortamar',
        codigo: 'hortamar',
        logo: `/assets/img/marcas/${TEMPORADA}/hortamar.jpg`,
        descripcion: '',
        stand: '9B08A',
        pabellon: 'P09',
    },
    {
        nombre: 'Indasol',
        url: '/participar/indasol',
        codigo: 'indasol',
        logo: `/assets/img/marcas/${TEMPORADA}/indasol.jpg`,
        descripcion: '',
        stand: '9C05',
        pabellon: 'P09',
    },
    {
        nombre: 'Gava (Kop Agro)',
        url: '/participar/gava',
        codigo: 'gava',
        logo: `/assets/img/marcas/${TEMPORADA}/gava.jpg`,
        descripcion: '',
        stand: '9A14',
        pabellon: 'P09',
    },
    {
        nombre: 'Hortichuelas',
        url: '/participar/lashortichuelas',
        codigo: 'lashortichuelas',
        logo: `/assets/img/marcas/${TEMPORADA}/lashortichuelas.jpg`,
        descripcion: '',
        stand: '9D13',
        pabellon: 'P09',
    },
    {
        nombre: 'Natural de Montaña',
        url: '/participar/naturaldemontana',
        codigo: 'naturaldemontana',
        logo: `/assets/img/marcas/${TEMPORADA}/naturaldemontana.jpg`,
        descripcion: '',
        stand: '3D08',
        pabellon: 'P03',
    },
    {
        nombre: 'Nature Choice',
        url: '/participar/naturechoice',
        codigo: 'naturechoice',
        logo: `/assets/img/marcas/${TEMPORADA}/naturechoice.jpg`,
        descripcion: '',
        stand: '9C07',
        pabellon: 'P09',
    },
    {
        nombre: 'Única',
        url: '/participar/unica',
        codigo: 'unica',
        logo: `/assets/img/marcas/${TEMPORADA}/unica.jpg`,
        descripcion: '',
        stand: '9D03',
        pabellon: 'P09',
    },
    {
        nombre: 'Rijk Zwaan',
        url: '/participar/rijkzwaan',
        codigo: 'rijkzwaan',
        logo: `/assets/img/marcas/${TEMPORADA}/rijkzwaan.jpg`,
        descripcion: '',
        stand: '9D23',
        pabellon: 'P09',
    },
    {
        nombre: 'Toledano Bio',
        url: '/participar/toledanohorticola',
        codigo: 'toledanohorticola',
        logo: `/assets/img/marcas/${TEMPORADA}/toledanohorticola.jpg`,
        descripcion: '',
        stand: '9A14',
        pabellon: 'P09',
    },
    {
        nombre: 'Vicasol',
        url: '/participar/vicasol',
        codigo: 'vicasol',
        logo: `/assets/img/marcas/${TEMPORADA}/vicasol.jpg`,
        descripcion: '',
        stand: '9B02',
        pabellon: 'P09',
    },
    {
        nombre: 'La Palma',
        url: '/participar/lapalma',
        codigo: 'lapalma',
        logo: `/assets/img/marcas/${TEMPORADA}/lapalma.jpg`,
        descripcion: '',
        stand: '9D09',
        pabellon: 'P09',
    },
]
export const participacionExtra = {
    nombre: 'Participación Extra',
    url: '/participar/extra',
    codigo: 'extra',
    logo: `/assets/img/marcas/${TEMPORADA}/extra.jpg`,
}
export const clientesFeria = clientes
export const clientesRedes = [
    ...clientes,
    {
        nombre: 'Sweet Palermo',
        url: '/participar/sweetpalermo',
        codigo: 'sweetpalermo',
        descripcion: '',
        stand: '9D23',
        pabellon: 'P09',
    },
]
